export default __webpack_public_path__ + "static/media/icon-menu-bonus-active.076aff3a.svg";